/**
 * Client-side "Sort by discount" for collection pages.
 * Values: discount-desc | discount-asc (URL ?sort_by=...)
 */
(function () {
  "use strict";

  var DISCOUNT_DESC = "discount-desc";
  var DISCOUNT_ASC = "discount-asc";
  var CARD = "[data-card-price][data-card-compare-at]";

  function escapeCssSelector(value) {
    if (window.CSS && typeof window.CSS.escape === "function") {
      return window.CSS.escape(value);
    }
    return String(value).replace(/["\\]/g, "\\$&");
  }

  function getVirtualizedScrollForGrid(grid) {
    if (!grid || !grid.id) return null;
    var selector = 'virtualized-scroll[target="#' + escapeCssSelector(grid.id) + '"]';
    return document.querySelector(selector);
  }

  function isDiscountSort(value) {
    return value === DISCOUNT_DESC || value === DISCOUNT_ASC;
  }

  function getSortModeFromUrl() {
    var p = new URL(window.location.href).searchParams.get("sort_by");
    return isDiscountSort(p) ? p : null;
  }

  function discountPercentFromDataset(el) {
    var price = parseInt(el.getAttribute("data-card-price"), 10);
    var compare = parseInt(el.getAttribute("data-card-compare-at"), 10);
    if (!Number.isFinite(price)) return 0;
    if (!Number.isFinite(compare) || compare <= 0 || compare <= price) return 0;
    return ((compare - price) / compare) * 100;
  }

  /**
   * Reorders only elements matching CARD; non-card siblings stay at fixed indices (e.g. promo banners).
   */
  function sortProductGrid(grid, mode) {
    if (!grid) return;
    var virtualizedScroll = getVirtualizedScrollForGrid(grid);
    if (virtualizedScroll && typeof virtualizedScroll.prepareForExternalReorder === "function") {
      virtualizedScroll.prepareForExternalReorder();
    }

    var children = Array.prototype.slice.call(grid.children);
    var result = new Array(children.length);
    var cardEntries = [];

    children.forEach(function (el, i) {
      if (el.matches(CARD)) {
        cardEntries.push({ el: el, i: i });
      } else {
        result[i] = el;
      }
    });

    if (cardEntries.length < 2) return;

    var decorated = cardEntries.map(function (entry, key) {
      return {
        el: entry.el,
        pct: discountPercentFromDataset(entry.el),
        key: key
      };
    });

    decorated.sort(function (a, b) {
      var cmp =
        mode === DISCOUNT_DESC
          ? b.pct - a.pct
          : a.pct - b.pct;
      if (cmp !== 0) return cmp;
      return a.key - b.key;
    });

    var didOrderChange = false;
    for (var o = 0; o < cardEntries.length; o++) {
      if (cardEntries[o].el !== decorated[o].el) {
        didOrderChange = true;
        break;
      }
    }
    if (!didOrderChange) return;

    cardEntries.forEach(function (entry, k) {
      result[entry.i] = decorated[k].el;
    });

    var frag = document.createDocumentFragment();
    for (var r = 0; r < result.length; r++) {
      if (result[r]) frag.appendChild(result[r]);
    }
    grid.appendChild(frag);

    if (virtualizedScroll && typeof virtualizedScroll.afterExternalReorder === "function") {
      virtualizedScroll.afterExternalReorder();
    }
  }

  function forEachProductList(fn) {
    document.querySelectorAll("product-list").forEach(function (grid) {
      if (grid.querySelector(CARD)) fn(grid);
    });
  }

  function applyDiscountSortFromUrl() {
    var mode = getSortModeFromUrl();
    if (!mode) {
      document.querySelectorAll("product-list").forEach(function (grid) {
        if (grid._discountSortObserver) {
          grid._discountSortObserver.disconnect();
          delete grid._discountSortObserver;
        }
      });
      return;
    }
    forEachProductList(function (grid) {
      sortProductGrid(grid, mode);
    });
    syncSortUi(mode);
    attachObservers();
  }

  function syncSortUi(mode) {
    document.querySelectorAll("facets-sort-popover x-listbox [role='option']").forEach(function (opt) {
      var v = opt.getAttribute("value");
      opt.setAttribute("aria-selected", v === mode ? "true" : "false");
    });
    document.querySelectorAll(".mosaic-sort__input").forEach(function (input) {
      input.checked = input.value === mode;
    });
  }

  function replaceUrlFromFacetEvent(detailUrl) {
    var u = new URL(detailUrl, window.location.origin);
    u.searchParams.delete("section_id");
    history.replaceState({}, "", u.pathname + u.search + u.hash);
  }

  /** facet:update — intercept discount sort before section fetch */
  document.addEventListener(
    "facet:update",
    function (event) {
      var url = event.detail && event.detail.url;
      if (!url) return;
      var sortBy = new URL(url).searchParams.get("sort_by");
      if (!isDiscountSort(sortBy)) return;
      event.stopImmediatePropagation();
      replaceUrlFromFacetEvent(url);
      applyDiscountSortFromUrl();
      document.body.classList.remove("open-mosaic-sort");
    },
    true
  );

  document.addEventListener("DOMContentLoaded", applyDiscountSortFromUrl);

  window.addEventListener("popstate", function () {
    requestAnimationFrame(applyDiscountSortFromUrl);
  });

  document.documentElement.addEventListener("theme:loading:end", function () {
    requestAnimationFrame(applyDiscountSortFromUrl);
  });

  var moTimer = null;
  function debouncedReapply() {
    if (!getSortModeFromUrl()) return;
    clearTimeout(moTimer);
    moTimer = setTimeout(applyDiscountSortFromUrl, 50);
  }

  function attachObservers() {
    if (!getSortModeFromUrl()) return;
    document.querySelectorAll("product-list").forEach(function (grid) {
      if (grid._discountSortObserver) return;
      var obs = new MutationObserver(debouncedReapply);
      obs.observe(grid, { childList: true });
      grid._discountSortObserver = obs;
    });
  }

  document.addEventListener("DOMContentLoaded", function () {
    attachObservers();
    document.documentElement.addEventListener("theme:loading:end", attachObservers);
  });
})();
